import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Composition } from '../../models/composition/composition';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class CompositionProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/composition';

  /**
   * Get all available compositions
   * @returns Observable of Composition array
   */
  public getAllCompositions(): Observable<ApiResponse<Composition[]>> {
    return this.httpClient.get<ApiResponse<Composition[]>>(`${this.baseUrl}/all`);
  }

  public createFiberCategory(category: Composition): Observable<ApiResponse<Composition>> {
    return this.httpClient.post<ApiResponse<Composition>>(this.baseUrl, category);
  }

  public updateFiberCategory(id: string, fiberCategory: Composition): Observable<ApiResponse<Composition>> {
    return this.httpClient.put<ApiResponse<Composition>>(`${this.baseUrl}/${id}`, fiberCategory);
  }

  public deleteFiberCategoryById(id: string): Observable<ApiResponse<void>> {
    return this.httpClient.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
